<div class="esf-overlay" [class.-is-open]="isOpen">
  <div class="esf-modal" [class.-is-open]="isOpen">
    <header class="esf-modal__header">
      <h3>
        <span class="space-after">{{ modalOptions?.title }}</span>
      </h3>
    </header>
    <div class="esf-modal__inner">
      <div class="esf-text-block">
        <p>{{ modalOptions?.paragraph }}</p>
      </div>
    </div>
    <footer class="esf-modal__footer">
      <div class="esf-submit-row">
        <div class="esf-submit-row__item">
          <button *ngIf="!showSpinner"
                  class="esf-button esf-button--standard esf-button--filled"
                  (click)="submitButtonClicked()">{{ modalOptions?.submitText }}</button>
          <app-spinner [name]="spinnerName"></app-spinner>
        </div>
        <div class="esf-submit-row__item">
          <button class="esf-button esf-button--standard esf-button--outlined"
                  (click)="cancelButtonClicked()">{{ modalOptions?.cancelText }}</button>
        </div>
      </div>
    </footer>
    <div class="esf-modal__close" (click)="setModalStatus(false)">
      <svg class="esf-icon esf-icon--darker" width="24" height="24">
        <use xlink:href="#esf-icon-close"></use>
      </svg>
    </div>
  </div>
</div>
